var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: {
      height: _vm.iframeVisible ? 'auto' : '322px'
    }
  }, [_vm.iframeVisible ? _c('iframe', {
    ref: "taxiFrame",
    staticClass: "taxi-widget my-2",
    style: `height: ${_vm.iframeHeight}px`,
    attrs: {
      "src": `${_vm.taxiWidgetBaseUrl}/widget.html?cacheBust=${_vm.cacheBust}`
    },
    on: {
      "load": _vm.initializeTaxiWidget
    }
  }) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }